<script setup lang="ts">
import { computed } from 'vue'
import { ISensorFormData } from '@/interfaces/components/createSensor/create-sensor.ts'
import { ISchemaSensor } from '@/interfaces/entities/schema_sensor'
import { SensorType, translateSensorType } from '@/interfaces/enums.ts'
import CardInfo from '@/components/Globals/CardInfo.vue'
import SchemaMappingTable from '@/components/Sensors/Create/Steps/SchemaStep/SchemaMappingTable.vue'

const props = defineProps<{
  formData: ISensorFormData
  selectedSchema: ISchemaSensor | null
}>()

const formattedSensorType = computed(() => {
  if (!props.formData.sensor_type) return '-'
  return translateSensorType(props.formData.sensor_type as SensorType)
})

const safeSchemaMapping = computed((): Record<string, string> => {
  if (!props.selectedSchema || !props.selectedSchema.schema) return {}
  return props.selectedSchema.schema as unknown as Record<string, string>
})
</script>

<template>
  <div class="max-w-4xl mx-auto w-full animate-fadeIn">
    
    <div class="text-center mb-10">
      <h2 class="text-2xl font-bold text-slate-900 dark:text-white">Confirmação</h2>
      <p class="text-body text-slate-500 dark:text-gray-400 mt-1">
        Verifique os dados abaixo antes de finalizar.
      </p>
    </div>

    <div class="space-y-10"> <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <CardInfo title="Nome do Sensor" :value="formData.sensor_name" />
        <CardInfo title="Tipo" :value="formattedSensorType" />
        <CardInfo title="Fabricante" :value="formData.manufacturer" />
        <CardInfo title="SubID" :value="formData.subid" />
        <div class="md:col-span-2">
           <CardInfo title="Endereço MAC" :value="formData.mac_address" />
        </div>
      </div>

      <div v-if="selectedSchema" class="pt-8 border-t border-stroke dark:border-strokedark">
        
        <div class="flex flex-col items-center justify-center mb-6">
           <span class="text-sm font-medium text-slate-500 uppercase tracking-wider mb-2">
             Modelo Atribuído
           </span>
           
           <div class="inline-flex items-center gap-2 px-4 py-1.5 bg-gray-100 text-slate-700 border border-gray-200 dark:bg-meta-4 dark:text-white dark:border-strokedark">
             <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
               <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
             </svg>
             <span class="font-bold text-lg">{{ selectedSchema.name }}</span>
           </div>
        </div>
        
        <SchemaMappingTable 
          :mapping="safeSchemaMapping" 
          variant="card" 
        />
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fadeIn { animation: fadeIn 0.4s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>